// extracted by mini-css-extract-plugin
module.exports = {"button":"_14cvH","icon":"wihZQ","facebook":"_12DYX","twitter":"_3FRVI","link":"-mRLP"};